
export const ROUTES = {
    HOME : '/',
    APARTAMENT : '/apartament',
    ABOUT: '/about',
    DOCUMENT: '/documents'
}